import { htmlToPlainText } from '.';

const htmlToPlainTextWithLineBreaks = (html: string) => {
  if (!html) return '';
  const convertedHtml = html
    .replace(/^<p[^>]*>/g, '')
    .replace(/<p[^>]*>/g, '\n\n')
    .replace(/<br>/g, '\n');
  return htmlToPlainText(convertedHtml);
};

export default htmlToPlainTextWithLineBreaks;
